import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AppointmentForm from '../components/AppointmentForm';

const AppointmentPage = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <div style={{ flex: 1 }} className="pt-5 mt-3 pb-5 bg-light">
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h1 className="display-5 fw-bold">Book an Appointment</h1>
              <p className="lead text-muted">
                We're here for you. Connect with our pastoral team for guidance, prayer, and support.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={7}>
              <AppointmentForm />
            </Col>
            <Col md={4} lg={3} className="mt-4 mt-md-0">
              <div className="card shadow-sm border-0 mb-3">
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-3">
                    <i className="bi bi-clock me-2 text-primary"></i>Office Hours
                  </h5>
                  <p className="mb-1">Monday – Friday</p>
                  <p className="mb-3 text-muted">9:00 AM – 6:00 PM</p>
                  <p className="mb-1">Saturday</p>
                  <p className="mb-0 text-muted">By appointment only</p>
                </div>
              </div>
              <div className="card shadow-sm border-0 mb-3">
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-3">
                    <i className="bi bi-geo-alt-fill me-2 text-primary"></i>Location
                  </h5>
                  <p className="mb-0 text-muted">
                    221 N Dooley Street<br />
                    Grapevine, TX 76051
                  </p>
                </div>
              </div>
              <div className="card shadow-sm border-0">
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-3">
                    <i className="bi bi-envelope-fill me-2 text-primary"></i>Contact
                  </h5>
                  <p className="mb-1">
                    <a href="mailto:info@jesuslebonberger.org" className="text-decoration-none">
                      info@jesuslebonberger.org
                    </a>
                  </p>
                  <p className="mb-0">
                    <a href="tel:8179873444" className="text-decoration-none">
                      (817) 987-3444
                    </a>
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default AppointmentPage;
